import {isArray} from 'ramda-adjunct';

import {settingsRoutes, testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function AccountingCodesList() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    if (actionKey !== 'redirectDetail') {
      return;
    }

    const id = isArray(rowId) ? rowId[0] : rowId;

    navigate(
      composePath(settingsRoutes.accountingCodesDetail, {
        params: {id},
      })
    );
  };

  return (
    <>
      <DmsDataGrid
        gridCode="accounting-context-codes"
        autoHeight
        predefinedColumns={['id']}
        actionCallback={actionCallback}
        data-testid={testIds.settings.accountingCodes('list')}
      />
    </>
  );
}
